<template>
  <div>
    <ContentPage headerText="Privacy & Cookie Policy" noContent />
    <div class="content">
      <div class="container">
        <div class="sections">
          <div>
            <h3>
              At Pilates Haven, we are committed to protecting your
              privacy. This privacy notice tells you what to expect when
              Pilates Haven collects personal information. It applies
              to information we collect about:
            </h3>
            <ul>
              <li>
                visitors to our websites;
              </li>
              <li>
                complainants and other individuals in relation to an enquiry;
              </li>
              <li>
                people who use our services; and
              </li>
              <li>
                job applicants and our current and former employees.
              </li>
            </ul>
          </div>
          <div>
            <h3>
              We use information held about you in the following ways:
            </h3>
            <ul>
              <li>
                to ensure that content from our site is presented in the most
                effective manner for you and for your computer;
              </li>
              <li>
                to provide you with information, products or services that you
                request from us or which we feel may interest you, where you
                have consented to be contacted for such purposes;
              </li>
              <li>
                to carry out our obligations arising from any contracts entered
                into between you and us;
              </li>
              <li>
                to notify you about changes to our service;
              </li>
            </ul>
            <p>
              We do not disclose personal information about individuals to
              advertisers or sell your information to any other organisation for
              marketing purposes.
            </p>
          </div>
          <div>
            <h3>
              Visitors to our websites
            </h3>
            <p>
              When someone visits https://pilates-haven.co.uk we do not make any
              attempt to find out the identities of those visiting our website.
              If we do want to collect personally identifiable information
              through our website, we will be up front about this. We will make
              it clear when we collect personal information and will explain
              what we intend to do with it.
            </p>
          </div>
          <div>
            <h3>
              People who email us
            </h3>
            <p>
              Any email sent to us, including any attachments, may be monitored
              and used by us for reasons of security and for monitoring
              compliance with office policy. Email monitoring or blocking
              software may also be used. Please be aware that you have a
              responsibility to ensure that any email you send to us is within
              the bounds of the law.
            </p>
          </div>
          <div>
            <h3>
              People who make a complaint
            </h3>
            <p>
              When we receive a complaint from a person we make up a file
              containing the details of the complaint. This normally contains
              the identity of the complainant and any other individuals involved
              in the complaint.
            </p>
            <p>
              We will only use the personal information we collect to process
              the complaint and to check on the level of service we provide.
            </p>
            <p>
              We will keep personal information contained in complaint files in
              line with our retention policy. It will be retained in a secure
              environment and access to it will be restricted according to the
              'need to know' principle.
            </p>
          </div>
          <div>
            <h3>
              People who enquire with us
            </h3>
            <p>
              Where enquiries are submitted to us we use the information
              supplied to process the enquiry. When consent is given, we will
              continue to contact the enquirer with information on services that
              we provide.
            </p>
            <p>
              We may retain personal information, in the form of names and email
              addresses, for direct marketing communications.
            </p>
            <p>
              Individuals can opt out of these communications at anytime by
              unsubscribing via a link included in emails or contacting us
              directly using the details at the end of this Policy.
            </p>
            <p>
              We will not share any personal data received through this method
              with 3rd parties.
            </p>
          </div>
          <div>
            <h3>
              People who use Pilates Haven
            </h3>
            <p>
              Pilates Haven offers various services to the public.
            </p>
            <p>
              We have to hold the details of the people who have requested the
              service in order to provide it. However, we only use these details
              to provide the service the person has requested and for other
              closely related purposes. For example, we might use information
              about people who have subscribed to any of our services to carry
              out a survey to find out if they are happy with the level of
              service they received.
            </p>
            <p>
              When people do subscribe to our services, they can cancel their
              subscription at any time and are given an easy way of doing this.
              We do not store financial details of our clients (credit or debit
              card numbers).
            </p>
          </div>
          <div>
            <h3>
              Job applicants, current, and former Organisation employees
            </h3>
            <p>
              When individuals apply to work at Pilates Haven, we
              will only use the information they supply to us to process their
              application. Where we want to disclose information to a third
              party, for example where we want to take up a reference or obtain
              a 'disclosure' from the Criminal Records Bureau we will not do so
              without informing them beforehand unless the disclosure is
              required by law. However there are also circumstances where we can
              pass on personal data without consent for example, to prevent and
              detect crime and to produce anonymised statistics.
            </p>
            <p>
              Once a person has taken up employment with Snetterton Auto
              Services, we will compile a file relating to their employment. The
              information contained in this will be kept secure and will only be
              used for purposes directly relevant to that person’s employment.
              Once their employment with Pilates Haven has ended, we
              will retain the file in accordance with the requirements of our
              retention schedule and then delete it.
            </p>
          </div>
          <div>
            <h3>
              Disclosure of personal information
            </h3>
            <p>
              In many circumstances we will not disclose personal data without
              consent. However when we investigate a complaint, for example, we
              will need to share personal information with Snetterton Auto
              Services or individual concerned and with other relevant bodies.
            </p>
            <p>
              There are also circumstances where we can pass on personal data
              without consent for example, to prevent and detect crime and to
              produce anonymised statistics.
            </p>
          </div>
          <div>
            <h3>
              Access to personal information
            </h3>
            <p>
              Pilates Haven tries to be as open as it can be in terms
              of giving people access to their personal information. Individuals
              can find out if we hold any personal information by making a
              'subject access request' under the General Data Protection
              Regulation.
            </p>
            <strong>If we do hold information about you we will:</strong>
            <ul>
              <li>
                give you a description of it;
              </li>
              <li>
                tell you why we are holding it;
              </li>
              <li>
                tell you who it could be disclosed to; and
              </li>
              <li>
                let you have a copy of the information in an intelligible form.
              </li>
            </ul>
            <p>
              To make a request from Pilates Haven for any personal
              information we may hold, you need to put the request in writing
              and either address it to us at the address provided below, or
              email us.
            </p>
            <p>
              If you agree, we will try to deal with your request informally,
              for example by providing you with the specific information you
              need over the telephone.
            </p>
            <p>
              If we do hold information about you, you can ask us to correct any
              mistakes by, once again, contacting us.
            </p>
            <p>
              As an individual, if you have issues accessing your personal
              information with any organisation you have the right to lodge a
              compliant with the ICO.
            </p>
          </div>
          <div>
            <h3>
              Your Rights as a Data Subject:
            </h3>
            <p>
              <strong>Right to Rectification -</strong> the right to request us
              to rectify inaccurate personal data.
            </p>
            <p>
              <strong>Right to Object -</strong> the right to object to
              processing based on either public interests or legitimate
              interests. Processing must stop, unless we demonstrate compelling
              grounds for continuing the processing or that the processing is
              necessary in connection with our legal rights.
            </p>
            <p>
              <strong>Right to Object to Direct Marketing</strong>
            </p>
            <p>
              <strong>Right to be Forgotten -</strong> the right to have us
              erase personal data without undue delay. Contingent on the
              occurrence of one of the following:
            </p>
            <ul>
              <li>
                The data is no longer necessary;
              </li>
              <li>
                You withdraw your consent (where consent is our legal basis for
                processing);
              </li>
              <li>
                We have no overriding grounds for continuing processing against
                the objectification;
              </li>
              <li>
                Processing was unlawful;
              </li>
              <li>
                Erasure is necessary with EU or national law.
              </li>
            </ul>
            <p>
              <strong>Right to Restrict Processing -</strong> the right to have
              us restrict processing if:
            </p>
            <ul>
              <li>
                The accuracy of the data is contested;
              </li>
              <li>
                Processing is unlawful;
              </li>
              <li>
                We no longer need the data for its original purpose, but need it
                for legal purposes;
              </li>
              <li>
                Erasure is pending.
              </li>
            </ul>
            <p>
              <strong>Right of Data Portability -</strong> the right to receive
              a copy of your data in a commonly used machine-readable format for
              transfer to another controller. This will either be in .xls or
              .csv format.<br />
            </p>
            <p>
              Pilates Haven neither makes a decision solely by
              automated means without any human involvement nor engages in
              automated processing of personal data to evaluate certain things
              about an individual. Hence your right related to automated
              decision making including profiling does not apply with us.
            </p>
            <p>
              Any formal subject access request should be made in writing to the
              address below. This will be provided free of charge. However we
              may charge a reasonable fee for repetitive, unfounded, or
              excessive requests or additional copies.
            </p>
          </div>
          <div>
            <h3>
              Who has access to your information?
            </h3>
            <p>
              We will not sell or rent your information to third parties.
            </p>
            <p>
              Third Party Service Providers working on our behalf: We may pass
              your information to our third party service providers, agents,
              subcontractors and other associated organisations for the purpose
              of performing a contract we have agreed with you, identifying and
              communicating with you, responding to your requests or enquiries,
              and improving our services.
            </p>
            <p>
              However, when we use third party service providers, we disclose
              only the personal information that is necessary to deliver the
              service and we have a contract in place that requires them to keep
              your information secure and not to use it for their own direct
              marketing purposes.
            </p>
            <p>
              We may also pass your information to governmental or regulatory
              bodies where a legal obligation arises.
            </p>
          </div>
          <div>
            <h3>
              Our policy towards children
            </h3>
            <p>
              Pilates Haven' services are not directed to
              individuals under 18. We do not knowingly collect Personal
              Information from children under 18. If we become aware that a
              child under 18 has provided us with Personal Information, we will
              take steps to delete such information. If you become aware that a
              child has provided us with Personal Information, please contact
              us.
            </p>
          </div>
          <div>
            <h3>
              Data storage, transfer and security
            </h3>
            <p>
              Pilates Haven takes security seriously. We take various
              steps to protect information you provide to us from loss, misuse,
              and unauthorized access or disclosure. These steps take into
              account the sensitivity of the information we collect, process and
              store, and the current state of technology.
            </p>
            <p>
              Any sensitive information (such as credit or debit card details)
              is encrypted and protected using industry standard SSL (HTTPS).
              Non-sensitive details (your email address etc.) are transmitted
              normally over the Internet, and this can never be guaranteed to be
              100% secure.
            </p>
            <p>
              Pilates Haven hosts data with hosting service providers
              within the EEA. The servers on which Personal Information is
              stored are kept in a controlled environment. While we take
              reasonable efforts to guard your Personal Information, no security
              system is impenetrable and due to the inherent nature of the
              Internet as an open global communications vehicle, we cannot
              guarantee that information, during transmission through the
              Internet or while stored on our systems or otherwise in our care,
              will be absolutely safe from intrusion by others, such as hackers.
              In addition, we cannot guarantee that any incidentally-collected
              Personal Information you choose to store on our Websites are
              maintained at levels of protection to meet specific needs or
              obligations you may have relating to that information.
            </p>
            <p>
              Where we have given (or where you have chosen) a password which
              enables you to access certain parts of our websites, you are
              responsible for keeping this password confidential. We ask you not
              to share your password with anyone.
            </p>
          </div>
          <div>
            <h3>
              Retention & Deletion
            </h3>
            <p>
              Pilates Haven retains your information while you or
              your company remains an active client, unless you ask us to delete
              your information. If you stop being an active client we will
              retain your information for the periods defined in our retention
              policy unless you request that your details be deleted. However,
              we will only contact you if we believe the information we intend
              to send to you could be of 'legitimate interest' to you or your
              company.
            </p>
            <p>
              If you have signed up to receive our newsletter or requested
              information from us, we will retain your information until you
              request to be removed/deleted. Subject to the exceptions described
              below, Pilates Haven deletes or anonymizes your
              information when it's reached the end of its retention period as
              per our policy or upon request from you. For further information
              regarding our retention periods and policy, please contact us via
              email or at the address provided at the end of this policy.
            </p>
            <strong
              >Subject to applicable law, Pilates Haven may retain
              information after account deletion:</strong
            >
            <ul>
              <li>
                If there is an unresolved issue relating to your account, such
                as an outstanding invoice on your account.
              </li>
              <li>
                If necessary for its legitimate business interests, such as
                fraud prevention.
              </li>
              <li>
                If we are required to by applicable law; and/or in aggregated
                and/or anonymized form.
              </li>
            </ul>
          </div>
          <div>
            <h3>
              Complaints or queries
            </h3>
            <p>
              Pilates Haven tries to meet the highest standards when
              collecting and using personal information. For this reason, we
              take any complaints we receive about this very seriously. We
              encourage people to bring it to our attention if they think that
              our collection or use of information is unfair, misleading or
              inappropriate. We would also welcome any suggestions for improving
              our procedures.
            </p>
            <p>
              If you believe we have processed your personal data in a way that
              does not comply with GDPR, we ask that in the first instance you
              contact us directly. Under GDPR you also have a right to make a
              complaint to the Information Commissioner’s Office (ICO) or other
              relevant supervisory body.
            </p>
            <p>
              This privacy notice was drafted with brevity and clarity in mind.
              It does not provide exhaustive detail of all aspects of Snetterton
              Auto Services collection and use of personal information. However,
              we are happy to provide any additional information or explanation
              needed. Any requests for this should be sent to the address below.
            </p>
          </div>
          <div>
            <h3>
              Links to other websites
            </h3>
            <p>
              This privacy notice does not cover the links within this site
              linking to other websites. We encourage you to carefully read the
              privacy policy of any website you visit.
            </p>
          </div>
          <div>
            <h3>
              What are Cookies
            </h3>
            <p>
              Cookies are small amounts of information which some websites store
              on your computer to make it easier for you to log on to and use
              them during future visits. In reality, a cookie is a small text
              file which is stored by the user's browser and contains data, not
              code, so it can't contain a virus or spyware. This doesn't mean
              that all cookies are harmless in intent, but they can only ever
              store information.
            </p>
          </div>
          <div>
            <h3>
              How we use your information
            </h3>
            <p>
              Organisation uses 'analytical' cookies on this site to allow us to
              monitor website traffic and analyse how visitors use it via Google
              Analytics. This service tracks information about how visitors
              interact with the site, including the number of visitors to our
              website, where visitors have come to the website from, and the
              pages they visit. We use this information to help us improve our
              website.
            </p>
            <p>
              Such information will not identify you personally as it is merely
              statistical data about our visitors and their use of our website.
              This statistical data is completely anonymous and does not
              identify any personal details whatsoever.
            </p>
            <p>
              All computers have the ability to decline cookies. You can
              configure your web browser to refuse cookies, or to be informed if
              a cookie is set. You can find out how to do this by clicking
              "help" on your browser menu.
            </p>
            <p>
              By using our website, you agree that we can place these types of
              cookies on your device.
            </p>
            <p>
              If you wish to find out more about cookies visit

              <a
                class="underline"
                href="https://allaboutcookies.org/"
                target="_blank"
                rel="noopener noreferrer"
                >allaboutcookies.org</a
              >
            </p>
          </div>
          <div>
            <h3>
              Changes to this privacy notice
            </h3>
            <p>
              We keep our privacy notice under regular review. This privacy
              notice was last updated on 08 April 2024.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ContentPage from '@/components/partials/ContentPage.vue'

export default {
  name: 'privacy-cookie-policy',
  components: {
    ContentPage
  }
}
</script>

<style lang="scss" scoped>
h3 {
  margin-bottom: 0;
}

ul {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-bottom: 0;

  font-weight: 500;

  strong {
    font-weight: 600;
  }
}

.content {
  padding-top: 64px;
  padding-bottom: 64px;
}

.sections {
  display: flex;
  flex-direction: column;
  gap: 5rem;

  > * {
    display: flex;
    flex-direction: column;
    gap: 2rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/PrivacyAndCookiePolicy.vue